import { setActiveNavLink } from 'src/pages/home/redux/actions';

const discardChangesBtnClickHandlerUtil = ({
    isPriceOverride,
    setPriceOverride,
    setRPPriceOverride,
    dispatch,
    setPriceOverridePage,
    filteredProduct,
    setPriceOverrideReason,
    setPricingNotes,
    reportUsageFormObj,
    priceOverRideDetails,
    myCaseResourceType,
    setFilteredProduct,
    reportPaymentGridData,
    setPriceOverrideTableData,
    isProcedureBtnClicked,
    isReplishBtnClicked,
    nextBtnClicked,
    setIsProcedureBtnClicked,
    setIsReplishBtnClicked,
    setNextBtnClicked,
    setReportPaymentScreenName,
    getModifiedButtonVisibilities,
    footerButtonStatuses,
    next,
    submit,
    setFooterButtonStatuses,
    procedurePageVisibility,
    screenSwitchOnReviewBtnClick,
    navigateToProcedureScreen,
    vendorCaseSstRefId,
    redirectToSpecifiedOrderForVendorCaseError,
    showReportPayment,
    setShowReportPayment,
    setReportPaymentGridData,
    storeUsageDataPresist,
    showUnsavedChangesPopup,
    navigationPath,
    history,
    getRoutePathWithParams,
    navLinkSelectHandler,
    selectedScreenToNavigate,
    setPediatricCheck,
    fromOrdersList,
    resetReportUsageData,
    resetReportUsageStates,
    resetNotes,
    unlockOrderFunc,
    setShowCancelPopUp,
    setShowUNiDPopUp,
    setShowUnsavedReportUsageChangesPopUp,
    myCaseRefId,
}) => {
    if (isPriceOverride) {
        setPriceOverride(false);
        setRPPriceOverride(false);
        dispatch(setPriceOverridePage(false));
        if (
            !filteredProduct.some(
                (x) => x.adjustedUsedQtyPrice || x.adjustedOtherQtyPrice
            )
        ) {
            setPriceOverrideReason('');
            setPricingNotes('');
        } else if (
            reportUsageFormObj.overridenReason?.length > 0 ||
            priceOverRideDetails?.priceOverriddenReason ||
            reportUsageFormObj.pricingNotes?.length > 0 ||
            priceOverRideDetails?.pricingNotes
        ) {
            setPriceOverrideReason(
                reportUsageFormObj.overridenReason ||
                    priceOverRideDetails?.priceOverriddenReason
            );
            setPricingNotes(
                reportUsageFormObj.pricingNotes ||
                    priceOverRideDetails?.pricingNotes
            );
        }
        if (myCaseResourceType === 'reportPayment') {
            setFilteredProduct(reportPaymentGridData);
            if (
                !reportPaymentGridData.some(
                    (x) =>
                        x.adjustedUsedQtyPrice ||
                        x.adjustedOtherQtyPrice ||
                        x.overrideUnitPrice
                )
            ) {
                setPriceOverrideReason('');
                setPricingNotes('');
            } else if (
                reportUsageFormObj.overridenReason?.length > 0 ||
                priceOverRideDetails?.priceOverriddenReason ||
                reportUsageFormObj.pricingNotes?.length > 0 ||
                priceOverRideDetails?.pricingNotes
            ) {
                setPriceOverrideReason(
                    reportUsageFormObj.overridenReason ||
                        priceOverRideDetails?.priceOverriddenReason
                );
                setPricingNotes(
                    reportUsageFormObj.pricingNotes ||
                        priceOverRideDetails?.pricingNotes
                );
            }
        }
        setPriceOverrideTableData([]);
    } else if (isProcedureBtnClicked || isReplishBtnClicked) {
        if (nextBtnClicked) {
            setIsProcedureBtnClicked(false);
            setIsReplishBtnClicked(false);
            dispatch(setReportPaymentScreenName('Review'));
            var modifiedButtonStatuses = getModifiedButtonVisibilities(
                myCaseResourceType,
                footerButtonStatuses,
                next,
                submit
            );
            setFooterButtonStatuses(modifiedButtonStatuses);
        } else {
            !procedurePageVisibility
                ? screenSwitchOnReviewBtnClick()
                : navigateToProcedureScreen();
            setIsProcedureBtnClicked(false);
            setIsReplishBtnClicked(false);
            setNextBtnClicked(false);
        }
    } else if (vendorCaseSstRefId) {
        redirectToSpecifiedOrderForVendorCaseError(vendorCaseSstRefId);
    } else if (showReportPayment && myCaseResourceType !== 'reportPayment') {
        setShowReportPayment(false);
        setReportPaymentGridData([]);
        dispatch(
            storeUsageDataPresist({
                name: 'showReportPayment',
                value: false,
            })
        );
        dispatch(
            storeUsageDataPresist({
                name: 'reportPayment',
                value: [],
            })
        );
    } else {
        if (showUnsavedChangesPopup && navigationPath) {
            if (navigationPath.includes('http'))
                window.location.href = navigationPath;
            else history.push(getRoutePathWithParams(navigationPath));
            navLinkSelectHandler(
                dispatch,
                setActiveNavLink,
                selectedScreenToNavigate
            );
        } else {
            dispatch(setPediatricCheck(''));
            history.push(
                fromOrdersList
                    ? getRoutePathWithParams('/orders')
                    : getRoutePathWithParams('/')
            );
        }
        localStorage.removeItem('myCaseRefUsage');
        resetReportUsageData();
        dispatch(resetReportUsageStates());
        dispatch(resetNotes());
        (myCaseRefId && myCaseRefId?.length > 0) && unlockOrderFunc({
            action:
                myCaseResourceType === 'reportPayment'
                    ? 'ReportPayment'
                    : myCaseResourceType === 'draft'
                    ? 'DraftUsageEdit'
                    : 'ReportUsage',
            myCaseRefId: myCaseRefId,
        });
    }
    setShowCancelPopUp(false);
    setShowUNiDPopUp(false);
    if (showUnsavedChangesPopup)
        dispatch(setShowUnsavedReportUsageChangesPopUp(false));
};

export default discardChangesBtnClickHandlerUtil;
